export default "__VITE_ASSET__CW5S2JiN__"